<template>
<div>

<h1 style="text-align: center;" class="mt-7">Account Settings</h1>
<br>
<div class="nav-tabs sc-bvTASY jPMoWD" style="overflow: scroll;display: flex;">
<router-link to="/dashboard/account" exact-active-class="activetabs" class="nav-item nav-link" style="background: none;border-radius: .5rem .5rem 0 0!important;border-left: .0625rem solid transparent; border-right: .0625rem solid transparent; border-top: .0625rem solid transparent;border-bottom: 0;">Account Information</router-link>
<router-link to="/dashboard/billing" exact-active-class="activetabs" class="nav-item nav-link" style="background: none;border-radius: .5rem .5rem 0 0!important;border-left: .0625rem solid transparent; border-right: .0625rem solid transparent; border-top: .0625rem solid transparent;border-bottom: 0;">Billing (invoices)</router-link>
</div>

</div>

</template>

<style>
a {
  color: #515151;
}
@media (max-width:991px) {
  .card{
    width:100%!important;
  }
}
.card-body {
    flex: 1 1 auto;
    padding: 1.5rem;
}
/* .row {
    display: flex;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
} */
.col-12 {
    flex: 0 0 100%;
    max-width: 100%;
}
.form-group {
    position: relative;
}
.form-group {
    margin-bottom: 1rem;
}
.text-dark, .text-dark:hover {
    color: #0d1431 !important;
}
.form-label {
    font-weight: 400;
    font-size: 1rem;
    display: block;
}
.text-danger, .text-danger:hover {
    color: #FA5252 !important;
}
.input-group {
    border-radius: 0.5rem;
    transition: all 0.2s ease;
}
.mb-4, .my-4 {
    margin-bottom: 1.5rem !important;
}
.input-group {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    width: 100%;
}
.input-group-prepend {
    margin-right: -2px;
}
.input-group-text {
    font-size: 0.875rem;
    transition: all 0.3s ease-in-out;
}
.fa, .fas {
    font-weight: 900;
}
.fa, .far, .fas {
    font-family: "Font Awesome 5 Free";
}
.input-group .form-control:not(:first-child) {
    border-left: 0;
    padding-left: 0;
}
.input-group > .form-control, .input-group > .form-control-plaintext, .input-group > .custom-select, .input-group > .custom-file {
    position: relative;
    flex: 1 1 auto;
    width: 1%;
    margin-bottom: 0;
}
.input-group .form-control:not(:first-child) {
    border-left: 0;
    padding-left: 0;
}
.text-center {
    text-align: center !important;
}
.animate-up-2, .animate-right-2, .animate-down-2, .animate-left-2, .scale-up-2, .scale-down-2 {
    transition: all 0.2s ease;
}
button:not(:disabled), [type="button"]:not(:disabled), [type="reset"]:not(:disabled), [type="submit"]:not(:disabled) {
    cursor: pointer;
}
.mr-2, .mx-2 {
    margin-right: 0.5rem !important;
}
.activetabs{
  background: #ffffff!important;
  border-color: #dde1ed!important;
  color: #6ca7ff!important;
}
.nav-tabs .nav-link:hover {
    border: none;
}
.editandowebsite {
    background-color: #f9fafb;
    border-color: #1e90ff5e;
    outline: 0;
    box-shadow: inset 0 1px 2px rgb(46 54 80 / 8%), 0 0 0 0.2rem rgb(38 43 64 / 20%);
}
</style>

  <script>
  import ClickOutside from 'vue-click-outside';

  export default {
    props:['propsdata'],
    data() {
      return {
      };
    },
    methods: {
    },
    mounted() {
    },
    // do not forget this section
directives: {
  ClickOutside
}
  };
  </script>



// WEBPACK FOOTER //
// src/account-tabs.vue